<div class="ion-text-center">
  <ion-text color="primary">
    <h3 class="questions">{{ 'enclosure-list.¿Dónde encuentra la falla?' | translate }}</h3>
  </ion-text>

  <img src='../../../../assets/imgs/loader.gif' *ngIf="blueprint && printLoader">

  <img [hidden]="printLoader" (load)="printLoader = false" *ngIf="blueprint" class="blueprint" [src]="blueprint"
    alt="Plano no disponible" (click)="openBlueprint()" onerror="this.src='../../../../assets/imgs/noimage.png';">
</div>

<ng-container *ngIf="!httpError">

  <ion-searchbar animated placeholder="{{ 'enclosure-list.Buscar'  | translate }}"
    type="text" debounce="300" (ionInput)="search($event)">
  </ion-searchbar>

  <div *ngIf="showLoader" class="ion-text-center">
    <ion-spinner name="lines"></ion-spinner>
  </div>

  <cc-skeletons [type]="skeleton"></cc-skeletons>


  <div *ngIf="enclosures.length">

    <ion-item (click)="selectEnclosure(encl.id)" class="ion-text-wrap"
      [ngClass]="{'selected-item': selectedEnclosureId === encl.id}" *ngFor="let encl of enclosures; let i = index">
      <ion-label class="ion-text-wrap">{{ encl.recinto_nombre }}</ion-label>
      <ion-icon *ngIf="selectedEnclosureId === encl.id" color="light" slot="end" name="checkmark"></ion-icon>
    </ion-item>

    <ion-infinite-scroll *ngIf="enclosures.length >= 20" threshold="100px" (ionInfinite)="loadMore($event)">
      <ion-infinite-scroll-content loadingSpinner="bubbles"
        loadingText="{{ 'enclosure-list.Cargando...'  | translate }}">
      </ion-infinite-scroll-content>
    </ion-infinite-scroll>
  </div>

  <div *ngIf="!enclosures.length && !skeleton.show && !showLoader" class="centered-content">
    <ion-text class="no-data" color="medium">
      <br>
      <h1>
        {{ 'enclosure-list.Sin resultados' | translate }}
      </h1>
    </ion-text>
  </div>
</ng-container>

<cc-http-error *ngIf="httpError" [errorMsg]="httpError" (retry)="retry()"></cc-http-error>

<div class="ion-padding-top ion-padding-bottom"></div>
